var GridSlider = {};
GridSlider.slider = function () {
  var $gridSlider = $('.js-grid-slider');
  $gridSlider.on('ready.flickity', function () {
    $gridSlider.css('visibility', 'visible');
  });
  var options = {
    cellAlign: 'left',
    groupCells: false,
    prevNextButtons: false,
    pageDots: false,
    dragThreshold: 3,
    selectedAttraction: 0.01,
    friction: 0.15,
    freeScrollFriction: 0.02
  };
  if (matchMedia('screen and (min-width: 768px)').matches) {
    options = {
      cellAlign: 'left',
      groupCells: true,
      prevNextButtons: false,
      pageDots: false,
      dragThreshold: 3,
      selectedAttraction: 0.01,
      friction: 0.15,
      freeScrollFriction: 0.02
    };
  }
  $gridSlider.flickity(options);
  var $prevButton = $('.js-flickity-prev');
  var $nextButton = $('.js-flickity-next');
  $prevButton.click(function () {
    $gridSlider.flickity('previous');
  });
  $nextButton.click(function () {
    $gridSlider.flickity('next');
  });
};
GridSlider.slider();
$(window).resize(function () {
  GridSlider.slider();
});


// WEBPACK FOOTER //
// ./scripts/components/sliders/popular-products.js